import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as types from './mutation-types';
import appData from './modules/appData';
import appConfig from "../api/appConfig";
import getInitialState from '../api/getInitialState';
import parseWaypointId from "../util/parseWaypointId";
import URI from 'urijs';
import $ from 'jquery'

const uri = new URI();
const query = uri.search(true);

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const initialState = getInitialState();

const thisKioskId = query.pos || query.location || initialState.thisKioskId;
let currentFloor = initialState.currentFloor;

if (thisKioskId && appConfig.kiosks[thisKioskId]) {
  currentFloor = appConfig.kiosks[thisKioskId].floor;
}


export default new Vuex.Store({
  actions,
  state: {
    currentFloor: currentFloor,
    currentLang: initialState.currentLang,
    currentShop: initialState.currentShop,
    currentCat: initialState.currentCat,
    searchIsOpen: initialState.searchIsOpen,
    searchQuery: initialState.searchQuery,
    isIdle: initialState.isIdle,
    showRestrooms: initialState.showRestrooms,
    activeShopModal: initialState.activeShopModal,
    isOffersModalActive: initialState.isOffersModalActive,
    currentModalOffer: initialState.currentModalOffer,
    autoScrollToCurrent: initialState.autoScrollToCurrent,
    pathFinderTargetShop: initialState.pathFinderTargetShop,
    thisKioskId: thisKioskId,
  },
  modules: {
    appData,
  },
  mutations: {
    [types.SWITCH_LANGUAGE] (state, langCode) {
      state.currentLang = langCode;
    },
    [types.SWITCH_FLOOR] (state, floorId) {
      // make sure the floor id is number before commiting
      // if the floorId is accidentally not a number, no floors will be rendered
      if (!isNaN(floorId)) {
        state.currentFloor = floorId;
      }
    },
    [types.SELECT_SHOP] (state, shopId) {
      state.currentShop = shopId;
    },
    [types.CLEAR_SHOP] (state) {
      state.currentShop = null;
    },
    [types.SELECT_CAT] (state, catId) {
      state.currentCat = catId;
    },
    [types.CLEAR_CAT] (state) {
      state.currentCat = null;
    },
    [types.OPEN_SEARCH] (state) {
      state.searchIsOpen = true;
    },
    [types.CLOSE_SEARCH] (state) {
      state.searchIsOpen = false;
      state.searchQuery = "";
    },
    [types.UPDATE_SEARCH_QUERY] (state, queryString) {
      state.searchQuery = queryString;
    },
    [types.START_IDLING] (state) {
      state.isIdle = true;
    },
    [types.END_IDLING] (state) {
      state.isIdle = false;
    },
    [types.SHOW_RESTROOMS] (state) {
      state.showRestrooms = true;
    },
    [types.HIDE_RESTROOMS] (state) {
      state.showRestrooms = false;
    },
    [types.TOGGLE_RESTROOMS] (state) {
      state.showRestrooms = !state.showRestrooms;
    },
    [types.SHOW_SHOP_MODAL] (state, shopId) {
      state.activeShopModal = shopId;
    },
    [types.HIDE_SHOP_MODAL] (state) {
      state.activeShopModal = null;
    },
    [types.SHOW_OFFERS_MODAL] (state) {
      state.isOffersModalActive = true;
    },
    [types.HIDE_OFFERS_MODAL] (state) {
      state.isOffersModalActive = false;
    },
    [types.CHANGE_MODAL_OFFER] (state, offerId) {
      state.currentModalOffer = offerId;
    },
    [types.ENABLE_AUTO_SCROLL_TO_CURRENT] (state) {
      state.autoScrollToCurrent = true;
    },
    [types.DISABLE_AUTO_SCROLL_TO_CURRENT] (state) {
      state.autoScrollToCurrent = false;
    },
    [types.UPDATE_PATH_FINDER_TARGET_SHOP] (state, shopId) {
      state.pathFinderTargetShop = shopId || null;
    },
  },
  getters: {
    currentLang: state => state.currentLang,
    currentFloor: state => state.currentFloor,
    currentShop: state => state.currentShop,
    currentCat: state => state.currentCat,
    searchIsOpen: state => state.searchIsOpen,
    searchQuery: state => state.searchQuery,
    isIdle: state => state.isIdle,
    showRestrooms: state => state.showRestrooms,
    activeShopModal: state => state.activeShopModal,
    isOffersModalActive: state => state.isOffersModalActive,
    currentModalOffer: state => state.currentModalOffer,
    autoScrollToCurrent: state => state.autoScrollToCurrent,
    pathFinderTargetShop: state => state.pathFinderTargetShop,
    thisKioskId: state => state.thisKioskId,
    thisKioskData: state => {
      return appConfig?.kiosks?.[state.thisKioskId];
    },
    pathFinderData: (state, getters) => {
      const targetShop = getters.shopById(state.pathFinderTargetShop);
      if (!state.pathFinderTargetShop || !targetShop) {
        return null;
      }

      const startingPoint = appConfig.waypoints[getters.thisKioskData.waypoint];
      let endPoints = [];
      $.each(appConfig.waypoints, (index, value) => {
        targetShop.rooms.forEach(room => {
          if (value.entranceOfRoom === room) {
            endPoints.push(value);
          }
        });
      });


      if (!endPoints.length) {
        return null;
      }

      const findTargetFloor = (endPoints, startingFloor) => {
        const endIsOnStartingFloor = endPoints.find(endPoint => {
          return parseWaypointId(endPoint.id).getFloor() === startingFloor;
        });
        if (endIsOnStartingFloor) {
          return startingFloor;
        } else {
          return parseWaypointId(endPoints[0].id).getFloor();
        }
      };

      const filterEndpointsByFloorId = (endPoints, floorId) => {
        return endPoints.filter(endPoint => parseWaypointId(endPoint.id).getFloor() === floorId);
      };

      const startingFloor = parseWaypointId(startingPoint.id).getFloor();

      const targetFloor = findTargetFloor(endPoints, startingFloor);

      const frames = () => {
        if (startingFloor === targetFloor) {
          return {
            topFrame: {
              floor: startingFloor,
              startingPoint: startingPoint,
              endPoints: filterEndpointsByFloorId(endPoints, startingFloor),
            },
            bottomFrame: null,
          };
        }

        let elevatorsDataKey = "elevatorsByFloor";
        if (targetFloor === 0 || targetFloor === 5 || targetFloor === 6 || startingFloor === 0) {
          elevatorsDataKey = "altElevatorByFloor";
        }

        let start = {
          floor: startingFloor,
          startingPoint: startingPoint,
          endPoints: [appConfig.waypoints[appConfig[elevatorsDataKey][String(startingFloor)]]],
        };

        let end = {
          floor: targetFloor,
          startingPoint: appConfig.waypoints[appConfig[elevatorsDataKey][String(targetFloor)]],
          endPoints: filterEndpointsByFloorId(endPoints, targetFloor),
        };

        if (start.floor > end.floor) {
          return {
            topFrame: start,
            bottomFrame: end,
          };
        } else {
          return {
            topFrame: end,
            bottomFrame: start,
          };
        }
      };

      const data = {
        ...frames(),
        startingFloor: startingFloor,
        targetFloor: targetFloor,
      };

      return data;
    },
  },
  strict: debug,
});

